export const ENTITIES_FETCH_SUCCESS = 'ENTITIES_FETCH_SUCCESS'
export const ENTITIES_FETCH_FAILED = 'ENTITIES_FETCH_FAILED'

export const RENAME_ENTITY_FETCH = 'RENAME_ENTITY_FETCH'
export const RENAME_ENTITY_SUCCESS = 'RENAME_ENTITY_SUCCESS'
export const RENAME_ENTITY_FAILED = 'RENAME_ENTITY_FAILED'

export const RENAME_COL_FETCH = 'RENAME_COL_FETCH'
export const RENAME_COL_SUCCESS = 'RENAME_COL_SUCCESS'
export const RENAME_COL_FAILED = 'RENAME_COL_FAILED'

export const DELETE_COL_FETCH = 'DELETE_COL_FETCH'
export const DELETE_COL_SUCCESS = 'DELETE_COL_SUCCESS'
export const DELETE_COL_FAILED = 'DELETE_COL_FAILED'

export const ADD_COL_FETCH = 'ADD_COL_FETCH'
export const ADD_COL_SUCCESS = 'ADD_COL_SUCCESS'
export const ADD_COL_FAILED = 'ADD_COL_FAILED'

export const RESET_CREATED_COL = 'RESET_CREATED_COL'

export const CHANGE_TYPE_TO_BASIC = 'CHANGE_TYPE_TO_BASIC'
export const CHANGE_TYPE_TO_COMPLEX = 'CHANGE_TYPE_TO_COMPLEX'
export const CHANGE_TYPE_SUCCESS = 'CHANGE_TYPE_SUCCESS'
export const CHANGE_TYPE_FAILED = 'CHANGE_TYPE_FAILED'

export const ENTITY_DELETE = 'ENTITY_DELETE'
export const ENTITY_DELETE_SUCCESS = 'ENTITY_DELETE_SUCCESS'
export const ENTITY_DELETE_FAILED = 'ENTITY_DELETE_FAILED'

export const SET_DEFAULT_VALUE = 'SET_DEFAULT_VALUE'
export const SET_DEFAULT_VALUE_SUCCESS = 'SET_DEFAULT_VALUE_SUCCESS'
export const SET_DEFAULT_VALUE_FAILED = 'SET_DEFAULT_VALUE_FAILED'
